import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  DataTableModule, ButtonModule, GrowlModule, InputTextModule,
  ConfirmDialogModule, ChartModule, SliderModule, DropdownModule,
  TabViewModule
} from 'primeng/primeng';

import { TaskRoutingModule } from './task-routing.module';

import {TaskComponent} from './task.component';
import {TaskSearchComponent} from '../task-search/task-search.component';
import {TaskService} from './task.service';
import {TaskSearchService} from './task-search.service';

@NgModule({
  imports: [
    CommonModule,
    TaskRoutingModule,
    FormsModule,
    DataTableModule, ButtonModule, GrowlModule, InputTextModule,
    ConfirmDialogModule, ChartModule, SliderModule, DropdownModule,
    TabViewModule
  ],
  declarations: [ TaskComponent, TaskSearchComponent ],
  providers: [ TaskService, TaskSearchService ]
})
export class TaskModule { }




// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task.module.ts